/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import {
  Button,
  CircularProgress,
  Grid,
  Hidden,
  ListItemIcon,
  ListItemText,
  Menu,
  alpha,
  useTheme,
} from "@mui/material";
import HypetBreadcrumbs from "../Breadcrumbs";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { useDispatch, useSelector } from "react-redux";
import CubeTimeDimensionSelector from "../CubeTimeDimesionSelector";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Axios from "../../../../Utils/AxiosConfig/axiosConfig";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import BookmarkRemoveIcon from "@mui/icons-material/BookmarkRemove";
import ShareIcon from "@mui/icons-material/Share";
import { loadSnackbar } from "../../../../Utils/util";
import { ExcelService } from "../../../../Utils/ExportToExcel";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import RefreshIcon from "@mui/icons-material/Refresh";
import UpdateIcon from "@mui/icons-material/Update";
import CompareBtn from "../../utils/CompareBtn";
import KpiSidebar from "../KpiManagement";
import SubHeader from "../SubHeader";
import KpiSidebarCategory from "../KpiManagementCategory";
import { isUserAllowed } from "../../../../Utils/SelfServiceHelper";

interface PageCTA {
  buttonName: string;
  buttonAction: string;
}
interface BreadcrumbsNavigationItem {
  menuName?: string;
  menuAction?: string;
}

interface InjectionMouldingHeaderProps {
  pageHeader?: string;
  pageCTA?: PageCTA[];
  navigationItem?: BreadcrumbsNavigationItem[];
  setMeasureType?: any;
  setTimeDimensions?: any;
  setTimeGranularity?: any;
  timeGranularity?: any;
  asset?: any;
  dateRange?: any;
  measure?: any;
  finalExcelData?: any;
  setCurrentList?: any;
  refresh?: boolean;
  setRefresh?: any;
  compareAssets?: any[];
  removeCompareAsset?: any;
  kpiDataPoints?: any[];
  kpiChangeSummary? : any[],
  setUpdatedKpiList?: any;
  updatedKpiList?: any[];
  setQueryKey?: any;
  isAssetHasSubCategory?: boolean;
  subCategoryData?: any[];
  assetId?: string;
  parentAssetId?: string;
}

const refreshOptions = [
  { value: 0, label: "Disabled" },
  { value: 30, label: "30 seconds" },
  { value: 60, label: "1 minute" },
  { value: 300, label: "5 minutes" },
  { value: 1800, label: "30 minutes" },
];

const ReportHeader: React.FC<InjectionMouldingHeaderProps> = ({
  pageHeader,
  navigationItem,
  setMeasureType,
  setTimeDimensions,
  setTimeGranularity,
  timeGranularity,
  asset,
  finalExcelData = [],
  setCurrentList = () => {},
  refresh = false,
  setRefresh = () => {},
  compareAssets = [],
  removeCompareAsset = () => {},
  kpiDataPoints = [],
  kpiChangeSummary = [],
  setUpdatedKpiList = () => {},
  updatedKpiList = [],
  setQueryKey = () => {},
  subCategoryData = [],
  isAssetHasSubCategory,
  assetId,
  parentAssetId,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [kpis, setKpis] = useState(kpiDataPoints);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorTroubleshootEl, setAnchorTroubleshootEl] = React.useState(null);
  const troubleShootMenuOpen = Boolean(anchorTroubleshootEl);
  const open = Boolean(anchorEl);
  const usersList = useSelector((state: any) => state.usersList);
  const usecaseList = useSelector((state: any) => state.usecaseList);
  const plantList = useSelector((state: any) => state.plantsList);
  const [currentUsecase, setCurrentUsecase] = React.useState<any>([]);
  const [isLoadingCSV, setIsLoadingCSV] = React.useState<any>(false);
  const [anchorElRefresh, setAnchorElRefresh] = React.useState(null);
  const refreshIntervalPreference = localStorage.getItem("refreshInterval");
  const [refreshInterval, setRefreshInterval] = useState(0);
  const openRefresh = Boolean(anchorElRefresh);
  const extractedUsecase = window.location.href.substring(
    window.location.href.indexOf("usecase/") + 8
  );
  //getting usecase from url
  const usecaseUrl = extractedUsecase.substring(
    0,
    extractedUsecase.indexOf("/")
  );
  //Get plant code
  const plantData = plantList.plants.find((plant: any) => plant?._id === asset?.plant_id)
  useEffect(() => {
    setCurrentUsecase(
      usecaseList.usecases.find((usecase: any) => {
        return usecase.routes_use_code === usecaseUrl;
      })
    );
  }, [usecaseList.usecases]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (e: any) => {
    setAnchorEl(e.currentTarget);
  };

  const exportCSV = async () => {
    const excelService = new ExcelService();
    setIsLoadingCSV(true);
    try {
      if (finalExcelData.length) {
        const overViewData = [
          {
            "Asset Name": `${asset?.asset_name}`,
            "Asset Component Name": `${asset?.asset_name}`,
            "Plant Name": `${plantData?.plant_name}`,
            "Report URL": window.location.href,
            "Selected Sensor":
              asset === undefined || asset === null ? "NA" : "Combined",
            Granularity:
              timeGranularity === "minute"
                ? "5 minute"
                : timeGranularity === "hour"
                ? "Hourly"
                : timeGranularity === "day"
                ? "Daily"
                : timeGranularity,
          },
        ];

        let excelSheetName = ["Asset Overview"];
        const temp = finalExcelData?.map(
          (item: any) => item?.[0]?.[`${plantData?.plant_code}FiveMinAgg.description`]
        );
        excelSheetName = [...excelSheetName, ...temp];

          excelService.exportAsExcelFile(
          [overViewData, ...finalExcelData],
          `NB ARCH Report Data- ${asset?.asset_name}${
            asset === undefined || asset === null ? "" : " -Combined"
          }-${new Date().getTime()}`,
          excelSheetName,
          currentUsecase?.use_case_alias
        );
        setIsLoadingCSV(false);
      } else {
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            isShow: true,
            message: "Unable to Load the resource",
            type: "error",
            open: true,
          },
        });
        setIsLoadingCSV(false);
      }
    } catch (err) {
      setIsLoadingCSV(false);
      // setIsError(true);
      dispatch(loadSnackbar());
    }
  };

  const addBookmark = () => {
    Axios.post(`users/addBookmarkReport`, {
      userId: usersList.currentUser._id,
      assetId: asset?._id,
      usecaseId: currentUsecase?._id,
    })
      .then((res) => {
        // After updating the bookmark details we need to update the current user data which is in the local state
        dispatch({
          type: "SET_CURRENT_USER",
          payload: res.data.updatedUserDetails,
        });
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            message: "Report successfully added to bookmarks",
            type: "success",
            open: true,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            message: "Something went wrong!",
            type: "error",
            open: true,
          },
        });
      });
  };

  const removeBookmark = () => {
    Axios.post(`users/removeBookmarkReport`, {
      userId: usersList.currentUser._id,
      assetId: asset?._id,
      usecaseId: currentUsecase?._id,
    })
      .then((res) => {
        // After updating the bookmark details we need to update the current user data which is in the local state
        dispatch({
          type: "SET_CURRENT_USER",
          payload: res.data.updatedUserDetails,
        });
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            message: "Report successfully removed from bookmarks",
            type: "success",
            open: true,
          },
        });
      })
      .catch(() => {
        dispatch({
          type: "LOAD_SNACKBAR",
          payload: {
            message: "Something went wrong!",
            type: "error",
            open: true,
          },
        });
      });
  };

  const handleClickRefresh = (e: any) => {
    setAnchorElRefresh(e.currentTarget);
  };

  const handleCloseRefresh = () => {
    setAnchorElRefresh(null);
  };

  const handleIntervalChange = (value: any) => {
    setRefreshInterval(value);
    localStorage.setItem("refreshInterval", value);
  };

  React.useEffect(() => {
    if (refreshIntervalPreference) {
      setRefreshInterval(Number(refreshIntervalPreference));
    }
  }, [refreshIntervalPreference]);

  useEffect(() => {
    const IntervalId = setInterval(() => {
      if (refreshInterval > 0) {
        setCurrentList([]);
        setRefresh(!refresh);
      }
    }, refreshInterval * 1000); // Convert seconds to milliseconds

    // Clear the interval when refreshInterval changes
    return () => clearInterval(IntervalId);
  }, [refreshInterval, refresh, setCurrentList, setRefresh]);

  const compare = () =>
    navigate("/usecase/injection-pdm/troubleshooting-module");

  return (
    <SubHeader leftSpacing={0}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ flexGrow: 1, px: 2 }}
      >
        <Grid item>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <IconButton color="inherit" onClick={() => navigate(-1)}>
              <ArrowBackIcon />
            </IconButton>
            <Box>
              <Typography variant="h4">{pageHeader}</Typography>
              <HypetBreadcrumbs navigationItem={navigationItem} />
            </Box>
          </div>
        </Grid>
        <Grid item>
          <Grid container spacing={1} padding={0}>
            <Grid item>
              <CubeTimeDimensionSelector
                timeGranularity={timeGranularity}
                setTimeGranularity={setTimeGranularity}
                setTimeDimensions={setTimeDimensions}
                setMeasureType={setMeasureType}
              />
            </Grid>
            <Grid item>
              <CompareBtn
                setAnchorTroubleshootEl={setAnchorTroubleshootEl}
                anchorTroubleshootEl={anchorTroubleshootEl}
                troubleShootMenuOpen={troubleShootMenuOpen}
                compareAssets={compareAssets}
                removeSelectedTag={removeCompareAsset}
                compare={compare}
                assetId={assetId}
                asset={asset}
                parentAssetId={parentAssetId}
              />
            </Grid>
            <Grid item>
              {isUserAllowed(usersList.currentUserPermissions) ? (
                <Button
                  sx={{
                    height: 35, // Set height (same as width for square)
                    padding: " 0 10px", // Remove extra padding
                    borderRadius: 1, // Optional: Adjust for rounded square look
                    backgroundColor: alpha(theme.palette.primary.main, 0.3),
                    color: "white", // Icon color
                    "&:hover": {
                      backgroundColor: "primary.dark", // Darker color on hover
                    },
                  }}
                  variant="contained"
                  onClick={() => setSidebarOpen(true)}
                >
                  Open KPI Sidebar
                </Button>
              ) : null}

              {
                isAssetHasSubCategory ? (
                  <KpiSidebarCategory
                    open={sidebarOpen}
                    onClose={() => setSidebarOpen(false)}
                    defaultKpis={kpis}
                    kpiChangeSummary={kpiChangeSummary}
                    onKpisUpdate={setKpis}
                    assetId={asset?._id}
                    subCategoryData={subCategoryData}
                    setUpdatedKpiList={setUpdatedKpiList}
                    updatedKpiList={updatedKpiList}
                    setQueryKey={setQueryKey}
                    enableAreaGrouping={isAssetHasSubCategory}
                  />
                ) : (
                  <KpiSidebar
                    open={sidebarOpen}
                    onClose={() => setSidebarOpen(false)}
                    defaultKpis={kpis}
                    onKpisUpdate={setKpis}
                    kpiChangeSummary={kpiChangeSummary}
                    assetId={asset?._id}
                    subCategoryData={subCategoryData}
                    setUpdatedKpiList={setUpdatedKpiList}
                    updatedKpiList={updatedKpiList}
                    setQueryKey={setQueryKey}
                    enableAreaGrouping={isAssetHasSubCategory}
                  />
                )}
            </Grid>
            <Grid item>
              <IconButton
                sx={{
                  width: 40, // Set width
                  height: 35, // Set height (same as width for square)
                  padding: 0, // Remove extra padding
                  borderRadius: 1, // Optional: Adjust for rounded square look
                  backgroundColor: alpha(theme.palette.primary.main, 0.3),
                  color: "white", // Icon color
                  "&:hover": {
                    backgroundColor: "primary.dark", // Darker color on hover
                  },
                }}
                aria-controls={openRefresh ? "refresh-menu" : undefined}
                aria-expanded={openRefresh ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClickRefresh}
                aria-label="Refresh Options"
                title="Refresh Options"
                disableRipple
              >
                <ManageHistoryIcon />
              </IconButton>
              <Menu
                id="refresh-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorElRefresh}
                open={openRefresh}
                onClose={handleCloseRefresh}
                TransitionProps={{
                  timeout: 0,
                }}
                className="hide-print"
              >
                <MenuList
                  style={{
                    background: "#343D70",
                    padding: "0px",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setCurrentList([]);
                      // fetchAnnotations();
                      setRefresh(!refresh);
                      handleCloseRefresh();
                    }}
                  >
                    <ListItemIcon>
                      <RefreshIcon
                        style={{ color: "white" }}
                        fontSize="medium"
                      />
                    </ListItemIcon>
                    <ListItemText>{"Refresh Now"}</ListItemText>
                  </MenuItem>
                  {refreshOptions.map((option) => (
                    <MenuItem
                      onClick={() => {
                        handleIntervalChange(Number(option.value));
                        handleCloseRefresh();
                      }}
                    >
                      <ListItemIcon>
                        {Number(option.value) === refreshInterval ? (
                          <UpdateIcon
                            style={{ color: "#1dac56" }}
                            fontSize="medium"
                          />
                        ) : (
                          <UpdateIcon
                            style={{ color: "white" }}
                            fontSize="medium"
                          />
                        )}
                      </ListItemIcon>
                      <ListItemText>{`Auto Refresh ${option.label}`}</ListItemText>
                    </MenuItem>
                  ))}
                </MenuList>
              </Menu>
            </Grid>
            <Grid item className="hide-print">
              <IconButton
                sx={{
                  width: 40, // Set width
                  height: 35, // Set height (same as width for square)
                  padding: 0, // Remove extra padding
                  borderRadius: 1, // Optional: Adjust for rounded square look
                  backgroundColor: alpha(theme.palette.primary.main, 0.3),
                  color: "white", // Icon color
                  "&:hover": {
                    backgroundColor: "primary.dark", // Darker color on hover
                  },
                }}
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                aria-label="Open to show more"
                title="Open to show more"
                disableRipple
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  "aria-labelledby": "long-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionProps={{
                  timeout: 0,
                }}
                className="hide-print"
              >
                <MenuList
                  style={{
                    background: "#343D70",
                    padding: "0px",
                  }}
                >
                  <Hidden mdDown>
                    <MenuItem
                      // style={{ backgroundColor: "#343D70" }}
                      onClick={() => {
                        window.print();
                        handleClose();
                      }}
                    >
                      <ListItemIcon>
                        <PictureAsPdfIcon
                          style={{ color: "white" }}
                          fontSize="small"
                        />
                      </ListItemIcon>
                      <ListItemText>Export PDF</ListItemText>
                    </MenuItem>
                  </Hidden>
                  <MenuItem
                    // style={{ backgroundColor: "#343D70" }}
                    onClick={() => {
                      exportCSV();
                    }}
                  >
                    <ListItemIcon>
                      <InsertDriveFileIcon
                        style={{ color: "white" }}
                        fontSize="small"
                      />
                    </ListItemIcon>
                    <ListItemText>
                      {isLoadingCSV === true ? (
                        <CircularProgress
                          size="19px"
                          style={{ color: "white" }}
                        />
                      ) : (
                        "Export Excel"
                      )}
                    </ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      if (
                        usersList.currentUser?.bookmarked_reports
                          ?.filter(
                            (data: any) =>
                              data?.usecase_id === currentUsecase?._id
                          )
                          ?.map((assetData: any) => assetData.assets)
                          .flat()
                          ?.includes(asset?._id)
                      ) {
                        removeBookmark();
                      } else {
                        addBookmark();
                      }
                    }}
                  >
                    <ListItemIcon>
                      {usersList.currentUser?.bookmarked_reports
                        ?.filter(
                          (data: any) =>
                            data?.usecase_id === currentUsecase?._id
                        )
                        ?.map((assetData: any) => assetData.assets)
                        .flat()
                        ?.includes(asset?._id) ? (
                        <BookmarkRemoveIcon
                          style={{ color: "white" }}
                          fontSize="small"
                        />
                      ) : (
                        <BookmarkAddIcon
                          style={{ color: "white" }}
                          fontSize="small"
                        />
                      )}
                    </ListItemIcon>
                    <ListItemText>
                      {usersList.currentUser.bookmarked_reports
                        ?.filter(
                          (data: any) =>
                            data?.usecase_id === currentUsecase?._id
                        )
                        .map((assetData: any) => assetData.assets)
                        .flat()
                        ?.includes(asset?._id)
                        ? "Remove Bookmark"
                        : "Bookmark Report"}
                    </ListItemText>
                  </MenuItem>
                  <MenuItem
                    // style={{ backgroundColor: "#343D70" }}
                    onClick={() => {
                      window.open(
                        "mailto:digitaltechnologyteam@niagarawater.com?Subject=" +
                          encodeURIComponent(
                            `Report Data- ${asset?.asset_name}${
                              asset.description === undefined
                                ? "- Combined"
                                : `- ${asset.description}`
                            }`
                          ) +
                          "&body=" +
                          encodeURIComponent(
                            `Hi team, please find the report for ${
                              asset?.asset_name
                            }${
                              asset === undefined || asset === null
                                ? " here."
                                : asset.description === undefined
                                ? "- Combined here."
                                : `-${asset.description} here.`
                            }\n\n Please copy the below link and paste it in your browser \n\n ${
                              window.location
                            } \r\n`
                          )
                      );
                    }}
                  >
                    <ListItemIcon>
                      <ShareIcon style={{ color: "white" }} fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Share Report</ListItemText>
                  </MenuItem>
                </MenuList>
              </Menu>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </SubHeader>
  );
};

export default ReportHeader;
